import { EntityType } from '@/common/Constants';
import { GatewaysApi, NodesApi, SensorsApi, TransceiversApi } from '@/api';
import { ApiUtils } from '@/common/ApiUtils';

export class LastCheckInService {
	private static transceiverApi: TransceiversApi = new TransceiversApi();
	private static sensorApi: SensorsApi = new SensorsApi();
	private static gatewayApi: GatewaysApi = new GatewaysApi();
	private static nodeApi: NodesApi = new NodesApi();

	public static async getLastCheckIn(
		entityType: string,
		entityId: number,
	): Promise<{ lastCheckInTimestamp?: number; errorMessage?: string }> {
		switch (entityType) {
			case EntityType.TRANSCEIVER:
				return this.getTransceiverLastCheckIn(entityId);
			case EntityType.SENSOR:
				return this.getSensorLastCheckIn(entityId);
			case EntityType.GATEWAY:
				return this.getGatewayLastCheckIn(entityId);
			case EntityType.NODE:
				return this.getNodeLastCheckIn(entityId);
			default:
				return { errorMessage: `Unable to get last check-in for ${entityType}, unsupported type` };
		}
	}

	private static async getTransceiverLastCheckIn(
		id: number,
	): Promise<{ lastCheckInTimestamp?: number; errorMessage?: string }> {
		try {
			const response = await this.transceiverApi.getTransceiverLastCheckInTime(id);
			return { lastCheckInTimestamp: response.data?.data?.lastCheckInTimestamp ?? undefined };
		} catch (e) {
			return ApiUtils.handleApiError(e, `Failed to get last check-in time for transceiver '${id}'`);
		}
	}

	private static async getSensorLastCheckIn(
		id: number,
	): Promise<{ lastCheckInTimestamp?: number; errorMessage?: string }> {
		try {
			const response = await this.sensorApi.getSensorLastCheckInTime(id);
			return { lastCheckInTimestamp: response.data?.data?.lastCheckInTimestamp ?? undefined };
		} catch (e) {
			return ApiUtils.handleApiError(e, `Failed to get last check-in time for sensor '${id}'`);
		}
	}

	private static async getGatewayLastCheckIn(
		id: number,
	): Promise<{ lastCheckInTimestamp?: number; errorMessage?: string }> {
		try {
			const response = await this.gatewayApi.getGatewayLastCheckInTime(id);
			return { lastCheckInTimestamp: response.data?.data?.lastCheckInTimestamp ?? undefined };
		} catch (e) {
			return ApiUtils.handleApiError(e, `Failed to get last check-in time for gateway '${id}'`);
		}
	}

	private static async getNodeLastCheckIn(
		id: number,
	): Promise<{ lastCheckInTimestamp?: number; errorMessage?: string }> {
		try {
			const response = await this.nodeApi.getNodeLastCheckInTime(id);
			return { lastCheckInTimestamp: response.data?.data?.lastCheckInTimestamp ?? undefined };
		} catch (e) {
			return ApiUtils.handleApiError(e, `Failed to get last check-in time for node '${id}'`);
		}
	}
}
